import axios from 'axios'
// import router from '../router/router'
import store from '../store'
import { Modal, message } from 'ant-design-vue'

const TIMEOUT = 1000 * 60 * 20
let ajaxNum = 0

export const service = axios.create({
  baseURL: '',
  timeout: TIMEOUT, // request timeout
  headers: {
    'Content-Type': 'application/json'
  },
  responseType: 'json',
  withCredentials: true // 跨域请求带cookie
})

service.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (config.showLoading) {
      //
      ajaxNum++
      !store.state.loading && loading() // 在需要显示loading的页面判断，未显示loading则显示
    }
    config.headers['token'] = store.state.auth.token
    // config.headers['token'] = '65e4bebb969d475db579a986daf6f935'
    if (config.method === 'get') {
      if (config.params.config) {
        Object.assign(config, config.params.config)
        delete config.params.config
      }
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  res => {
    if (res.config.showLoading) {
      ajaxNum--
      ajaxNum === 0 && loaded()
    }
    if (res.data.status === 0) {
      return res.data.data
    } else {
      message.error('错误信息：' + res.data.msg)
      return Promise.reject(res.data.msg)
    }
  },
  ({message = '', config}) => {
    if (config.showLoading) {
      ajaxNum--
      ajaxNum === 0 && loaded()
    }

    if (config.silent) {

      return
    }

    Modal.error({title: '请求出错了 ', content: message, okText: '确定'})
  }
)

export function get(url) {
  return function (params = {}, config = {}) {
    return service.get(url, {params: Object.assign({}, params, {config})})
  }
}

export function post(url) {
  return function (data, config = {}) {
    return service.post(url, data, config) // data是要传过去的，config是请求自己的配置，用于执行程序的逻辑
  }
}

export default {
  get,
  post
}

export function loading() {
  store.commit('change_loading', true)
}

export function loaded() {
  store.commit('change_loading', false)
}
